<div class="flex flex-wrap justify-center gap-6 max-w-[70rem] mx-auto px-4 py-8">
  <div class="flex-1 min-w-[20rem] max-w-[22rem]">
    <p-card class="shadow-md">
      <div class="flex flex-col justify-between items-center gap-12 p-8">
        <img alt="Sisdemanda" height="98" ngSrc="logo.png" width="300"/>

        <p class="text-center break-words text-red-500">
          {{ mensagem() ?? 'Acesso negado.' }}
          <br/>
          <span class="text-sm">Entre em contato com o seu administrador.</span>
        </p>
        <p-button (click)="goToHome()"
            (keydown.enter)="$event.preventDefault(); goToHome()"
            (keydown.space)="$event.preventDefault(); goToHome()" class="w-full" styleClass="btn-gray">
          <app-icon-arrow-left/>
          Voltar para página inicial
        </p-button>

      </div>
    </p-card>
  </div>

</div>
